export default "/static/vspin_tiny.png";